import fastSetStyle from '@gaia/utils/mapbox/fastSetStyle';
import {useEffect, useRef} from 'react';

export function useUpdateMapboxStyle(map: MapboxMap | undefined, style: GaiaMapboxStyle) {
    const prev = useRef<GaiaMapboxStyle>();
    useEffect(() => {
        if (map) {
            fastSetStyle(map, prev.current, style);
            prev.current = style;
        }
    });
}
